import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../types';
import type { IGetPlansParams } from '../../apis/plan/types';
import { handleError } from '../../../components/ui/err/handleError';
import { queries } from '../../queries';

export default function useGetPlans(params: IGetPlansParams) {
  return useQuery({
    ...queries.plans.list(params),
    select: (data) => data.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
